import axios from 'axios'
import url from '../urls'

function parseCreatedAssignmentId (response) {
  const d = response?.data
  if (typeof d === 'number' && Number.isFinite(d)) return d
  if (typeof d === 'string' && d.trim() !== '') {
    const n = parseInt(d, 10)
    if (Number.isFinite(n)) return n
  }
  if (d != null && typeof d === 'object') {
    const n = Number(d.id ?? d.teacherTyperAssignmentId ?? d.assignmentId)
    if (Number.isFinite(n) && n > 0) return n
  }
  return null
}

function normalizeStudentIds (studentIds) {
  return [
    ...new Set(
      (studentIds || [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0)
    )
  ]
}

function mapStudentsToAssignment (teacherTyperAssignmentId, studentIds) {
  const ids = normalizeStudentIds(studentIds)
  if (!ids.length) {
    return Promise.reject(new Error('无有效学生 ID，无法绑定作业'))
  }
  return Promise.allSettled(
    ids.map((studentId) =>
      axios.post(url.TyperAssignmentMappingUrl, {
        teacherTyperAssignmentId,
        studentId
      })
    )
  ).then((results) => {
    const failed = results
      .map((r, i) => ({ r, studentId: ids[i] }))
      .filter(({ r }) => r.status === 'rejected')
    if (failed.length) {
      const err = new Error(
        `${failed.length} 名学生绑定失败`
      )
      err.teacherTyperAssignmentId = teacherTyperAssignmentId
      err.failedStudentIds = failed.map((f) => f.studentId)
      throw err
    }
    return { teacherTyperAssignmentId, mappedCount: ids.length }
  })
}

export default {
  /** 创建单份作业并依次为每位学生建立 mapping */
  assignToStudents (_context, { assignment, studentIds }) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.TyperAssignmentTeacherAssignmentUrl, assignment)
        .then((createRes) => {
          const teacherTyperAssignmentId = parseCreatedAssignmentId(createRes)
          if (!teacherTyperAssignmentId) {
            reject(new Error('创建作业成功但未返回作业 ID'))
            return
          }
          return mapStudentsToAssignment(teacherTyperAssignmentId, studentIds)
            .then((result) => resolve({ ...result, createRes }))
            .catch((err) => {
              err.message = `作业已创建 (ID ${teacherTyperAssignmentId})，${err.message}`
              reject(err)
            })
        })
        .catch((error) => reject(error))
    })
  },
  /** 复用已有作业：仅 mapping，不新建 */
  mapExistingAssignmentToStudents (_context, { teacherTyperAssignmentId, studentIds }) {
    const id = Number(teacherTyperAssignmentId)
    if (!Number.isFinite(id) || id <= 0) {
      return Promise.reject(new Error('无效的作业 ID'))
    }
    return mapStudentsToAssignment(id, studentIds)
  },
  getTeacherAssignments (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(url.TyperAssignmentTeacherUrl, { params: data })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  createTeacherAssignment (_context, assignment) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.TyperAssignmentTeacherAssignmentUrl, assignment)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  bindAssignmentToStudent (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.TyperAssignmentMappingUrl, {
          teacherTyperAssignmentId: data.teacherTyperAssignmentId,
          studentId: data.studentId
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getStudentAssignments (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(url.TyperAssignmentStudentUrl, { params: data })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getTeacherStudentAssignments (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(url.TyperAssignmentTeacherStudentUrl, { params: data })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getAssignmentById (_context, data) {
    return new Promise((resolve, reject) => {
      const assignmentId =
        data?.assignmentId ?? data?.teacherTyperAssignmentId ?? data?.id
      axios
        .get(`${url.TyperAssignmentDetailUrl}/${assignmentId}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  generateFromResult (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.TyperAssignmentGenerateUrl, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
}
